import axios from 'axios';

import { logError } from 'services/logging/logging';

const CHECK_INTERVAL = 15000; // 15 seconds
const CONSECUTIVE_FAILURE_THRESHOLD = 3;

export let isNewVersionAvailable = false;
let currentVersion: string | null = null;
let consecutiveFailures = 0;

export const startVersionCheck = () => {
  isNewVersionAvailable = false;
  consecutiveFailures = 0;
  setInterval(checkForUpdate, CHECK_INTERVAL);
};

const checkForUpdate = async () => {
  try {
    const response = await axios.get<string>('/version.txt', {
      headers: { 'Cache-Control': 'no-cache' },
    });

    consecutiveFailures = 0;

    const latestVersion = response.data;
    if (!currentVersion) {
      currentVersion = latestVersion;
      return;
    }

    if (latestVersion !== currentVersion) {
      isNewVersionAvailable = true;
    }
  } catch (error) {
    consecutiveFailures++;
    // Transient failures (e.g. 500 mid-deploy, 404 in local dev) are expected
    // and harmless — the poller simply skips this interval. Only log after
    // several consecutive failures, which indicates a real infrastructure issue.
    if (consecutiveFailures >= CONSECUTIVE_FAILURE_THRESHOLD) {
      logError(error);
    }
  }
};
